import React from 'react'
import TourneyOverview from './TourneyOverview'
import TourneyDetails from './TourneyDetails'
import Clubs from './Clubs'
import Sponsors from './Sponors'
import Social from './Social'
import Standings from './Standings'
import TeamStandings from './TeamStandings'
import MiniTeamStandings from './MiniTeamStandings'
import SlamStandings from './SlamStandings'
import Register from './Register'
import LoginRegister from './LoginRegister'
import Ads from './Ads'
import BigFish from './BigFish'
import {config} from '../config'
import Header from './Header'
import PrimaryButton from './PrimaryButton'
import SecondaryButton from './SecondaryButton'
import { useTournamentDetails } from '../hooks/useTournamentDetails'
import { useUserLoginDetails } from '../hooks/useUserLoginDetails'
import { useUserTimezone } from '../hooks/useUserTimezone'
import { useAnglerPinnedTournaments } from '../hooks/useAnglerPinnedTournaments'
import { Helmet } from "react-helmet"
import AdSenseWidget from './AdSenseWidget'; // adjust the path according to your folder structure

import '../App.css';

const txdomain = config()['tourneyx-url']

/*Chaitraly 05/Mar/2024 - rules pdf issue . path from linode */
const linode_url_only = config()['linode-url']

const Tournament = (props) => {
  //console.log('props value passed to get details:::', props);
  
  //const tournamentId = props.match.params.tournamentId
  
  const tournamentSlug = props.match.params.slug
  
  
  //console.log('tournament slug value found::',tournamentSlug);
  const hash = props.location.hash
  const tournamentDetails = useTournamentDetails(tournamentSlug)
  const get_user_information = useUserLoginDetails(tournamentSlug)

  const browser_title = tournamentDetails.tournament_title;
  //console.log('Logged in get_user_information found for user_id:::', get_user_information);

  const set_user_information = get_user_information;

  console.log('set_user_information response :::', set_user_information);

  const get_upcoming_tourney_countdown = useUserTimezone (tournamentSlug)
  const get_pinned_tournaments = useAnglerPinnedTournaments(set_user_information)

  // Check if logged-in user is super-admin or director
  if( ( set_user_information && set_user_information?.role === '1') || ( set_user_information && set_user_information?.user_id === tournamentDetails?.user_id )  ){

    // For super-admin, director condition
    if(tournamentDetails?.hide_fish_records === '1'){
      var hide_fish_records = 0;
    }else{
      var hide_fish_records = 0;
    }
  }else{
    // Check if logged in user is assigned as a judge
    if((tournamentDetails?.judge_list && tournamentDetails?.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( set_user_information && set_user_information?.user_id) > -1) == true ) ){

      var hide_fish_records = 0;

    }else{
      
      // Regular user, check hide_fish_records value 
      if(tournamentDetails?.hide_fish_records === '1'){
        var hide_fish_records = 1;
      }else{
        var hide_fish_records = 0;
      }
    }
  }

  console.log('hide_fish_records variable OP in Tournament js', hide_fish_records);

  //console.log('Upcoming tournament countdown value:::', get_upcoming_tourney_countdown);

  return (
    <>
    <Helmet>
      <title>{browser_title}</title>
    </Helmet>
    <div>
      <Header hidelinks={false} user_information = {set_user_information} upcoming_tourney_countdown={get_upcoming_tourney_countdown} get_pinned_tournaments={get_pinned_tournaments}/>
    </div>
    {
      (!tournamentDetails.tournamentId) 
        ? <div></div>
        : <div>
            <div className="wrapper">  
              <div className=' section-title'>
                <h2>{tournamentDetails.tournament_title ? tournamentDetails.tournament_title : ''}</h2>
              </div>
              
              {

                (tournamentDetails && tournamentDetails?.tourney_type == 15) ?

                // Condition for XLF-BBPH Tourney Type - 15
                <div className=" tourney-border tourney-left">
                <TourneyDetails tournamentDetails={tournamentDetails} />
                <Register tournamentDetails={tournamentDetails} user_information={set_user_information}	/>
                <LoginRegister tournamentDetails={tournamentDetails} user_information={set_user_information}	/>
                &nbsp;
                {/* 06/Dec/2024 Add code here for Daily Big Fish button */
                

                  (tournamentDetails && tournamentDetails?.show_standings === '0') ?

                    // Check if logged in user is super-admin or tournament director. Here show_standings flag value is 0.

                    (  ( set_user_information && set_user_information.role === '1' )  || ( set_user_information && set_user_information.user_id === tournamentDetails?.user_id )    ) ?

                    // Show big fish for super-admin, tourney-director even when standings have been hidden
                    <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                    :

                    // Check if logged in user is assigned as a judge for the tournament, if YES, then allow him to see the daily big fish

                    ( (tournamentDetails?.judge_list && tournamentDetails?.judge_list.length > 0 ) &&  ( (tournamentDetails?.judge_list.indexOf( set_user_information && set_user_information.user_id) > -1) === true )  ) ?
                    
                    <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                    :
                    <></>
                    
                    :

                    // Here show_standings flag value is 1. 
                    // Also check if hide_fish_records value is 0 or 1.

                    (hide_fish_records == 0 ) ?
                    <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                    :
                    <></>
                }
                
                  {
                    (tournamentDetails && tournamentDetails.show_standings === '0') ?
                      
                    // Check if logged in user is super-admin or tournament director 

                    (  ( set_user_information && set_user_information.role === '1' )  || ( set_user_information && set_user_information.user_id === tournamentDetails.user_id )    ) ?
                    <>
                    { 
                    
                      ( set_user_information && set_user_information.role === '1' ) ?
                        <div className='no-standings-standings-only'><h3>Standings are hidden to the general public. You are seeing them because you are a site admin.</h3></div> 
                      :
                        <div className='no-standings-standings-only'><h3>Standings are hidden to the general public. You are seeing them because you are the tournament director. </h3></div> 
                    
                    }
                    <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    
                    </>
                  
                    :

                    // Check if logged in user is assigned as a judge for the tournament, if YES, then allow him to see the standings
                    ( (tournamentDetails.judge_list && tournamentDetails.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( set_user_information && set_user_information.user_id) > -1) === true )  ) ?
                    <>

                      <div className='no-standings-standings-only'><h3>Standings are hidden to the general public. You are seeing them because you are a tournament judge.</h3></div> 
                      <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    </>

                    :

                    // This condition is shown for other anglers, if show_standings flag is set to 0.
                    <div className='no-standings-standings-only'><h3>The Tournament is currently OFFLINE pending Final Results.</h3></div>
                    
                    : 

                    // Show standing records for other anglers
                    // Also check if hide_fish_records value is set to 0/1.

                    (tournamentDetails && tournamentDetails.hide_fish_records === '1') ?
                   
                    // Check if logged in user is super-admin or tournament director 

                    (  ( set_user_information && set_user_information.role === '1' )  || ( set_user_information && set_user_information.user_id === tournamentDetails.user_id )    ) ?
                    <>
                    { 

                      ( set_user_information && set_user_information.role === '1' ) ?
                        <div className='no-standings-standings-only'><h3>Fish records are hidden to the general public. You are seeing them because you are a site admin.</h3></div> 
                      :
                        <div className='no-standings-standings-only'><h3>Fish records are hidden to the general public. You are seeing them because you are the tournament director. </h3></div> 

                    }
                    <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />

                    </>

                    :

                    // Check if logged in user is assigned as a judge for the tournament, if YES, then allow him to see the standings
                    ( (tournamentDetails.judge_list && tournamentDetails.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( set_user_information && set_user_information.user_id) > -1) === true )  ) ?
                    <>

                      <div className='no-standings-standings-only'><h3>Fish records are hidden to the general public. You are seeing them because you are a tournament judge.</h3></div> 
                      <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    </>

                    :

                    // This condition is shown for other anglers, if hide_fish_records flag is set to 0.
                    <>
                    <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    </>
                    
                   
                    :

                    // Show regular standings with fish records to the user.
                    <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    
                  }        
                </div> 

                // End of condition for XLF-BBPH type tourney

                :

                // Condition for tournament types other than Tourney Type - 15

                <div className=" tourney-border tourney-left">
                <TourneyDetails tournamentDetails={tournamentDetails} />
                <Register tournamentDetails={tournamentDetails} user_information={set_user_information}	/>
                <LoginRegister tournamentDetails={tournamentDetails} user_information={set_user_information}	/>
                &nbsp;
                {/* 06/Dec/2024 Add code here for Daily Big Fish button */
                (tournamentDetails && tournamentDetails?.show_standings === '0') ?

                // Check if logged in user is super-admin or tournament director. Here show_standings flag value is 0.

                (  ( set_user_information && set_user_information.role === '1' )  || ( set_user_information && set_user_information.user_id === tournamentDetails?.user_id )    ) ?

                // Show big fish for super-admin, tourney-director even when standings have been hidden
                <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                :

                // Check if logged in user is assigned as a judge for the tournament, if YES, then allow him to see the daily big fish

                ( (tournamentDetails?.judge_list && tournamentDetails?.judge_list.length > 0 ) &&  ( (tournamentDetails?.judge_list.indexOf( set_user_information && set_user_information.user_id) > -1) === true )  ) ?
                
                <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                :
                <></>
                
                :

                // Here show_standings flag value is 1. 
                // Also check if hide_fish_records value is 0 or 1.

                (hide_fish_records == 0 ) ?
                <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                :
                <></>
              }
                
                  {
                    (tournamentDetails && tournamentDetails.show_standings === '0') ?
                      
                    // Check if logged in user is super-admin or tournament director 

                    (  ( set_user_information && set_user_information.role === '1' )  || ( set_user_information && set_user_information.user_id === tournamentDetails.user_id )    ) ?
                    <>
                    { 
                    
                      ( set_user_information && set_user_information.role === '1' ) ?
                        <div className='no-standings-standings-only'><h3>Standings are hidden to the general public. You are seeing them because you are a site admin.</h3></div> 
                      :
                        <div className='no-standings-standings-only'><h3>Standings are hidden to the general public. You are seeing them because you are the tournament director. </h3></div> 
                    
                    }
                    
                    { 
                      (tournamentDetails && tournamentDetails.slam_tournament) ?
                      <SlamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />
                      :

                      (tournamentDetails && (tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16)) ? 
                      
                        (tournamentDetails.tourney_type == 4) ?
                        <TeamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />

                        :

                        <MiniTeamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />

                      
                      : <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                  
                    }
                    </>
                  
                    :

                    // Check if logged in user is assigned as a judge for the tournament, if YES, then allow him to see the standings
                    ( (tournamentDetails.judge_list && tournamentDetails.judge_list.length > 0 ) &&  ( (tournamentDetails.judge_list.indexOf( set_user_information && set_user_information.user_id) > -1) === true )  ) ?
                    <>

                      <div className='no-standings-standings-only'><h3>Standings are hidden to the general public. You are seeing them because you are a tournament judge.</h3></div> 
                      { 
                        (tournamentDetails && tournamentDetails.slam_tournament) ?
                        <SlamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />
                        :

                        (tournamentDetails && (tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16)) ? 
                        
                          (tournamentDetails.tourney_type == 4) ?
                          <TeamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />

                          :

                          <MiniTeamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />

                        : <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    
                      }

                    </>

                    :

                    // This condition is shown for other anglers
                    <div className='no-standings-standings-only'><h3>The Tournament is currently OFFLINE pending Final Results.</h3></div>
                    
                    : 
                    
                    // Show standings information, if they are not hidden
                    (tournamentDetails.slam_tournament) ?
                    <SlamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />
                    :

                    (tournamentDetails.tourney_type == 4 || tournamentDetails.tourney_type == 16) ? 

                      (tournamentDetails.tourney_type == 4)?
                      <TeamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />
                    
                      :

                      <MiniTeamStandings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information} hash={hash} />


                    : <Standings details={tournamentDetails} tournamentId={tournamentDetails.id} user_information={set_user_information}  hash={hash} />
                    
                  }        
              </div>

                // End of condition for regular type tourney
              }


              <div className="tourney-right">
                <Social />
                <PrimaryButton href={`${txdomain.replace('https://', 'https://live.')}/?id=${tournamentDetails.id}`} text='TOURNEYX LIVE LEADERBOARD' />

                {

                  (tournamentDetails && tournamentDetails?.show_standings === '0') ?

                    // Check if logged in user is super-admin or tournament director. Here show_standings flag value is 0.

                    (  ( set_user_information && set_user_information.role === '1' )  || ( set_user_information && set_user_information.user_id === tournamentDetails?.user_id )    ) ?

                    // Show big fish for super-admin, tourney-director even when standings have been hidden
                    <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                    :

                    // Check if logged in user is assigned as a judge for the tournament, if YES, then allow him to see the daily big fish

                    ( (tournamentDetails?.judge_list && tournamentDetails?.judge_list.length > 0 ) &&  ( (tournamentDetails?.judge_list.indexOf( set_user_information && set_user_information.user_id) > -1) === true )  ) ?
                    
                    <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                    :
                    <></>
                    
                    :

                    // Here show_standings flag value is 1. 
                    // Also check if hide_fish_records value is 0 or 1.

                    (hide_fish_records == 0 ) ?
                    <BigFish tournamentId={tournamentDetails.id} tourneyType={tournamentDetails.tourney_type} length_measurement_symbol = {tournamentDetails.length_unit} weight_measurement_symbol = {tournamentDetails.weight_unit} tournamentDetails={tournamentDetails} user_information={set_user_information}/>

                    :
                    <></>


                }
                
                
                
                
                
                <TourneyOverview tournamentDetails={tournamentDetails} user_information={set_user_information} get_pinned_tournaments={get_pinned_tournaments} />

                {
                  (tournamentDetails.clubs ) ? 
                  <Clubs club_information = {tournamentDetails.clubs}/>
                  :null
                }
               
                <Sponsors {...tournamentDetails} />

                {tournamentDetails.rules ?
                
                <SecondaryButton href={`${linode_url_only}/rules/${tournamentDetails.rules}`} text='View Rules'/>
                : null}
                {tournamentDetails.terms ?
                <SecondaryButton href={`${linode_url_only}/terms/${tournamentDetails.terms}`} text='View Terms &amp; Conditions'/>
                : null}

                {tournamentDetails.maps ?
                <SecondaryButton href={`${linode_url_only}/maps/${tournamentDetails.maps}`} text='Launch Maps'/>
                : null}

                <Register tournamentDetails={tournamentDetails} user_information={set_user_information}	/>
                <LoginRegister tournamentDetails={tournamentDetails} user_information={set_user_information}	/>
                {
                    /*
                    TODO: Add validation for only super-admin to see the tournament id
                    */

                    (set_user_information && set_user_information.role === '1') ?
                    <div>
                      <b>TOURNAMENT ID: &nbsp;</b>{tournamentDetails.id} <br></br>
                    </div>
                    :
                    null
                    
                }
                
                <Ads ads={tournamentDetails.ads} />
                <AdSenseWidget /> 
              </div>

            </div>
            
        </div>
      

    }
    </>
  )
}

export default Tournament